import { FeeSchedule } from './types';
import { ReduxAction } from '../core';

export class FeeScheduleAction {
  public static SET_BILLING_PROVIDER_ID = `FEE_SCHEDULE/SET_BILLING_PROVIDER_ID`;
  public static SET_PAYER_ID = `FEE_SCHEDULE/SET_PAYER_ID`;
  public static SET_CPT_SEARCH = `FEE_SCHEDULE/SET_CPT_SEARCH`;
  public static SET_FEE_SCHEDULE_DATA_FETCHING = `FEE_SCHEDULE/SET_FEE_SCHEDULE_DATA_FETCHING`;
  public static SET_FEE_SCHEDULE_DATA = `FEE_SCHEDULE/SET_FEE_SCHEDULE_DATA`;
  public static SAVE_FEE_SCHEUDLE = `FEE_SCHEDULE/SAVE_FEE_SCHEUDLE`;
  public static FEE_SCHEDULE_RECEIVED = `FEE_SCHEDULE/FEE_SCHEDULE_RECEIVED`;
}

export function setFeeScheduleDataFetching(value: boolean): ReduxAction<boolean> {
  return {
    type: FeeScheduleAction.SET_FEE_SCHEDULE_DATA_FETCHING,
    data: value,
  };
}

export function setFeeSchedule(value: FeeSchedule[]): ReduxAction<FeeSchedule[]> {
  return {
    type: FeeScheduleAction.SET_FEE_SCHEDULE_DATA,
    data: value,
  };
}

export function setPayerId(id: string): ReduxAction<string> {
  return {
    type: FeeScheduleAction.SET_PAYER_ID,
    data: id,
  };
}

export function setBillingProviderId(id: number): ReduxAction<number> {
  return {
    type: FeeScheduleAction.SET_BILLING_PROVIDER_ID,
    data: id,
  };
}

export function saveFeeSchedule(feeSchedule: FeeSchedule, isNew: boolean): ReduxAction<{ feeSchedule: FeeSchedule; isNew: boolean }> {
  return {
    type: FeeScheduleAction.SAVE_FEE_SCHEUDLE,
    data: {
      feeSchedule: feeSchedule,
      isNew: isNew,
    },
  };
}

export function feeScheduleReceived(feeSchedule: FeeSchedule): ReduxAction<FeeSchedule> {
  return {
    type: FeeScheduleAction.FEE_SCHEDULE_RECEIVED,
    data: feeSchedule,
  };
}

export function setCptSearch(query: string): ReduxAction<string> {
  return {
    type: FeeScheduleAction.SET_CPT_SEARCH,
    data: query,
  };
}
